<template>
  <div class="wrapper d-flex align-center justify-center">
    <v-card class="login-card pa-6" elevation="6">
      <v-card-title class="justify-center mb-4">
        <img src="/img/logo2.png" width="150" />
      </v-card-title>

      <div class="text-center">
        <h2 class="text-h5 font-weight-bold mb-2">Acesso Negado</h2>
        <p class="text-subtitle-1 mb-6">Você não tem permissão para acessar este recurso.</p>

        <v-btn
          id="naoAutorizado.voltarInicioBtn"
          color="primary"
          @click="$router.push({ name: 'home' })"
          rounded
          large
        >
          Voltar para o inicio
        </v-btn>
      </div>
    </v-card>
  </div>
</template>

<script>
export default {
  name: "NaoAutorizado",
};
</script>

<style scoped>
.wrapper {
  height: 100vh;
  width: 100vw;
  background-image: url("../assets/background.png");
  background-size: cover;
  background-position: center;
}

.login-card {
  width: 90vw;
  max-width: 500px;
  background-color: rgba(255, 255, 255, 0.85);
  border-radius: 16px;
}
</style>
